import getConfig from 'next/config'

import {
  GetActiveBidsProps,
  getUserBids as getUserBidsLib,
  useGetActiveBids as useGetActiveBidsLib,
} from '@nx/api'

const { publicRuntimeConfig } = getConfig()

export const getUserBids = (props: Omit<GetActiveBidsProps, 'baseURL'>) =>
  getUserBidsLib({ baseURL: publicRuntimeConfig.WEB_API_URL, ...props })

export const useGetActiveBids = () =>
  useGetActiveBidsLib({ baseURL: publicRuntimeConfig.WEB_API_URL })
